import React, { Component } from 'react'


class TableHeader extends Component {

    render() {
        return (
            <thead>
                <tr>
                    {
                        this.props.data.map((header, index) => {
                            return (<th key={'header-' + index}>{header}</th>)
                        })
                    }
                </tr>
            </thead>)
    }
}

export default TableHeader